import { render, staticRenderFns } from "./ph.vue?vue&type=template&id=1d29f37e&scoped=true&"
import script from "./ph.vue?vue&type=script&lang=js&"
export * from "./ph.vue?vue&type=script&lang=js&"
import style0 from "./ph.vue?vue&type=style&index=0&id=1d29f37e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d29f37e",
  null
  
)

export default component.exports